function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShrink = function SvgShrink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none",
    viewBox: "-5 -10 84 84"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M75.11 28.123c5.026 0 5.026 7.633 0 7.633H58.878l6.909 6.91c3.553 3.552-1.844 8.95-5.397 5.397-1.93-1.93-13.241-12.91-13.99-14.145-1.577-2.598.519-4.564.565-4.677L60.39 15.816c3.553-3.553 8.95 1.844 5.397 5.397l-6.909 6.91zM40.756 70.11c0 5.026-7.633 5.026-7.633 0V-6.231c0-5.026 7.633-5.026 7.633 0zM13.489 48.064c-3.553 3.553-8.95-1.844-5.397-5.397L15 35.757H-1.231c-5.026 0-5.026-7.634 0-7.634H15l-6.91-6.909c-3.552-3.553 1.845-8.95 5.398-5.397l13.992 14.149c.916 1.58.666 3.422-.568 4.674z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgShrink;